
const AppConsts = {
    NAME: process.env.REACT_APP_TITLE,
    API_PATH: process.env.REACT_APP_API_PATH
}

export default AppConsts;